import { combineReducers } from 'redux';
import { loginReducer, modalReducer, toast, orderlist_upcoming, orderlist_completed, master, masterValue} from "./index"
import { createHttpReducer } from "./http";

const storeDetails = createHttpReducer("STORE_DETAILS");

const storePackages = createHttpReducer("STORE_PACKAGES_TOPUP");

const storeRecharge = createHttpReducer("STORE_PACKAGES_RECHARGE");

const purchasePackage = createHttpReducer("PURCHASE_PACKAGE");

const purchaseOnline = createHttpReducer("PURCHASE_ONLINE");

const changePwd = createHttpReducer("CHANGE_PWD");

const storeBook = createHttpReducer("STORE_BOOK");




export default combineReducers({
    loginReducer,
    modalReducer,
    storeDetails,
    storePackages,
    purchasePackage,
    changePwd,
    toast,
    purchaseOnline,
    storeBook,
    orderlist_upcoming,
    orderlist_completed,
    master,
    masterValue,
    storeRecharge
})